import React, {useRef} from "react";
import {observer} from "mobx-react";
import {ExplorerOnboardingTooltipContainerBox} from "./boxes/explorer-onboarding-tooltip-container.box";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {DotLottiePlayer} from "../../../lottie-player/dot-lottie-player.component";
import {DotLottieCommonPlayer} from "@dotlottie/react-player";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";
import {ExplorerOnboardingTooltipTitleContainerBox} from "./boxes/explorer-onboarding-tooltip-title-container.box";
import {ExplorerOnboardingTooltipXButtonBox} from "./boxes/explorer-onboarding-tooltip-x-button.box";

interface ExplorerOnboardingTooltipProps extends ComponentServicesPick<'bottomNavigationBar'> {
    closeTooltipCallback: () => void;
}

const ComponentBody: React.FC<ExplorerOnboardingTooltipProps> = observer((props) => {
    const services = useServices();
    let lottieRef = useRef<DotLottieCommonPlayer>(null);
    let ExplorerIcon = services.theme.currentTheme.icons.exploreOutlinedIcon;

    const navigateToExplorer = () => {

        //If in the future we want the 'NEW' badge to disappear from the menu after the menu is clicked, uncomment the next line
        //services.videoSlides.setShownExplorerMenuBadgeCurrentSession();

        props.closeTooltipCallback();

        services.analytics.sendOrbitUserFlowEvent("Tooltip", "CTA_Click", "TT_Bubble");

        services.linksNavigation.navigateLink({
            linkId: 'videoSlideExploreLink'
        });

    }

    const renderLottiePlayer = () => {
        return (
            <DotLottiePlayer
                style={{width: "75px", height: "100%", padding: "2em 0"}}
                ref={lottieRef}
                src={services.theme.currentTheme.assets.lottie_json.explore_swipe_phone_gesture_lottie.toString()}
                autoplay={true}
                loop={true}
                rendererSettings={{
                    preserveAspectRatio: 'xMidYMid slice', // Scales the animation
                }}
            />
        );
    }

    const renderTitleSection = () => {
        return (
            <ExplorerOnboardingTooltipTitleContainerBox>
                <ExplorerIcon size={3.7}/>
                <span className={'explorer-menu-onboarding-title-text'}>
                  {services.translation.translate('EXPLORE')}
                </span>
                <span className={'explorer-menu-onboarding-title-new-box'}>
                  {services.translation.translate('EXPLORER_BADGE_NEW')}
                </span>
            </ExplorerOnboardingTooltipTitleContainerBox>
        );
    }

    const renderMainSection = () => {
        return (
            <div className={'explorer-menu-onboarding-button-container'}>
                <p>
                    {services.translation.translate('ONBOARDING_BOTTOM_NAV_BAR_EXPLORE_MAIN_TEXT')}
                </p>
                <Button preset={'primary'} fullWidth onClick={navigateToExplorer}>
                    {services.translation.translate('ONBOARDING_BOTTOM_NAV_BAR_EXPLORE_SECONDARY_TEXT')}
                </Button>
            </div>
        );
    }

    const _xButtonClicked = () => {
        services.analytics.sendOrbitUserFlowEvent("Tooltip", "X_Click", "TT_Bubble");

        props.closeTooltipCallback();
    }

    return (
      <ExplorerOnboardingTooltipContainerBox bottom={props.bottomNavigationBar.bottomNavbarHeight - 0.5}>
          <ExplorerOnboardingTooltipXButtonBox onClick={_xButtonClicked}/>
          {renderTitleSection()}
          {renderLottiePlayer()}
          {renderMainSection()}
      </ExplorerOnboardingTooltipContainerBox>
    );
})

export const ExplorerOnboardingTooltip = withServices(ComponentBody, ['bottomNavigationBar']);